import React from 'react';
import Reveal from '../ui/Reveal';
import Button from '../ui/Button';

export default function ClaritySession() {
  const bookSession = () => {
    window.open('https://topmate.io/mugdha_clarity90/2028348', '_blank');
  };

  return (
    <section id="book" className="py-32 bg-brand-terra text-brand-cream relative overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 border border-brand-cream/20 rounded-full opacity-50" />
      <div className="absolute -bottom-24 -left-24 w-72 h-72 border border-brand-cream/20 rounded-full opacity-50" />
      
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center relative z-10">
        <Reveal>
          <h2 className="font-serif text-5xl md:text-6xl mb-8 leading-tight">
            Diagnosis first. <br className="hidden md:block" /> Prescription second.
          </h2>
        </Reveal>
        
        <Reveal delay={0.2}>
          <p className="text-xl md:text-2xl font-light mb-12 text-brand-cream/90 leading-relaxed max-w-2xl mx-auto">
            If growth feels slower than the effort you are putting in, there is usually one operational bottleneck quietly capping everything. Let's find it.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="grid md:grid-cols-3 gap-6 text-left max-w-3xl mx-auto mb-16 border-y border-brand-cream/20 py-8">
            <div>
              <span className="block font-medium mb-1">90-Minute Session</span>
              <span className="text-sm font-light text-brand-cream/70">Deep 1:1 working session.</span>
            </div>
            <div>
              <span className="block font-medium mb-1">Not a Pitch Call</span>
              <span className="text-sm font-light text-brand-cream/70">Real operational diagnosis.</span>
            </div>
            <div>
              <span className="block font-medium mb-1">Not Mindset Coaching</span>
              <span className="text-sm font-light text-brand-cream/70">Structural problem solving.</span>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.4}>
          <Button variant="secondary" className="bg-brand-cream text-brand-terra hover:bg-transparent hover:text-brand-cream border-brand-cream text-lg px-10 py-5" onClick={bookSession}>
            Book a Clarity Session
          </Button>
        </Reveal>
      </div>
    </section>
  );
}